import gql from 'graphql-tag';

export const GETEMPLEADOSEMANA = gql`
  query ($empleado: String!, $semana: String!) {
    empleadoSemana(empleado: $empleado, semana: $semana) {
      id
      meta{
        dia
        metaHora
        metaDia
        horario
        fecha
        esCompensado
      }
      tienda
      semana
      empleado
    }
  }
`;

export const GETEMPLEADOSEMANATIENDA = gql`
  query ($empleado: String!, $semana: String!, $tienda:String) {
    empleadoSemanaTienda(empleado: $empleado, semana: $semana, tienda:$tienda) {
      id
      meta{
        dia
        metaHora
        metaDia
        horario
        fecha
        esCompensado
      }
      tienda
      semana
      empleado
      observaciones
    }
  }
`;

export const ADDEMPLESEM = gql`
  mutation ($empleSem: String) {
    addEmpleadoSem(empleSem: $empleSem) {
      id
      meta {
        dia
        metaHora
        metaDia
        horario
        fecha
        esCompensado
      }
      tienda
      semana
      empleado
    }
  }

`;

export const UPDATEEMPLESEM = gql`
  mutation ($id: String!, $empleSem: String) {
    updateEmpleadoSem(id: $id, empleSem: $empleSem) {
      id
      meta {
        dia
        metaHora
        metaDia
        horario
        fecha
        esCompensado
      }
      tienda
      semana
      empleado
    }
  }
`;

export const GETEMPLEADO = gql`
  query getEmpleado($id:String){
    devolverEmpleado(id:$id){
      id
      nombre
    }
  }
`;


export const GETDETALLEEMPLEADO = gql`
  query devolverInfoTienda($ano: Int, $semana: Int, $ti: Int!, $empleado:String!, $fecha:String!) {
    semana: semanaXId(id: $semana) {
      id
      tienda
      fecha
      ventasSem
      estado {
        creada
        presupuesto
        horario
        enejecucion
        finalizada
      }
      horario {
        dias {
          nombre
          horaInicio
          horaCierre
        }
      }
      mPorcentaje {
        estado
        dias {
          porcentaje
          horas {
            txtHora
            porcentaje
            precio
          }
          precio
          txtDia
        }
      }
    }
    ventas: ventas(ano: $ano, semana: $semana, tienda: $ti) {
      fecha
      cantidad
      cajero
      vendedor
      articulos {
        valor
      }
    }
    empleado: devolverEmpleado(id: $empleado) {
      id
      nombre
      tienda
    }
    
    em: empleadoSemana(empleado:$empleado,semana:$fecha){
      id
      meta{
        dia
        metaHora
        metaDia
        horario
        fecha
        esCompensado
      }
      semana
    }
    
    tienda: tienda(id:$ti){
      id
      idDB
      nombre
      
    }
  }
`;


export const BUSQUEDAEMPLEADO = gql`
  query ($id:String, $nombre:String, $doc:String){
    devolverTiendaDeEmpleado(id:$id, nombre: $nombre, doc:$doc){
      id
      nombre
      tienda
      doc
    }
  }
`;

export const EMPLEADOTIENDA = gql`
  query empleadoTienda($tienda:String){
    empleadoTienda(tienda:$tienda){
      id
      nombre
      tienda
      doc
      cargo{
        id
        cargo
      }
    }
  }
`;
